import { FieldHookConfig, useField } from 'formik';
import { Entity } from 'types/common';
import { ServiceUserGroupPicker } from '../pickers/AutocompletePickers/ServiceUserGroupPicker';
import { IFieldProps } from './FormRender/IFormFieldSetting';

export const FormServiceUserGroupPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<string> | null> & IFieldProps) => {
  const [field, meta, helpers] = useField<Entity<string> | null>(props);
  return (
    <ServiceUserGroupPicker
      name={props.name}
      placeholder={props.placeholder}
      label={label}
      onChange={value => {
        helpers.setValue(value, true);
        if (props.onChange) {
          props.onChange(value);
        }
      }}
      onBlur={field?.onBlur}
      value={field.value}
      error={meta?.error !== undefined}
      variant="filled"
      helperText={meta.error}
      fullWidth={props.fullWidth}
      info={props.info}
      predicates={props.predicates}
      disabled={props.disabled}
    />
  );
};
